var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Sentry from '@sentry/browser';
import { toast } from '../components/Toast/Toast';
import { loadImages } from './loadImage';
var ImageRender = /** @class */ (function () {
    function ImageRender(imageSet, width, height, scale) {
        if (width === void 0) { width = 750; }
        if (height === void 0) { height = 1200; }
        if (scale === void 0) { scale = 2; }
        var finalScale = 1;
        if (window.devicePixelRatio) {
            finalScale = scale;
        }
        if (/MQQBrowser/.test(window.navigator.userAgent)) {
            finalScale = 0.8;
        }
        this.imageSet = imageSet;
        this.width = width * finalScale;
        this.height = height * finalScale;
        this.scale = finalScale;
        this.createCanvas();
    }
    ImageRender.measureText = function (text, scale) {
        if (scale === void 0) { scale = 3; }
        var canvas = ImageRender.shadowCanvas;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            throw new Error('Canvas not supported');
        }
        if (window.devicePixelRatio) {
            ctx.scale(scale, scale);
        }
        return ctx.measureText(text);
    };
    ImageRender.prototype.createCanvas = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        var ctx = canvas.getContext('2d');
        if (!canvas || !ctx) {
            toast.fail('Canvas not supported', 2);
            return;
        }
        this.canvas = canvas;
        this.ctx = ctx;
    };
    ImageRender.prototype.setTextTemplate = function (textSet, textData) {
        textSet.map(function (textNode) {
            textNode.text.map(function (textContent) {
                for (var key in textData) {
                    textContent.content = textContent.content.replace("{{" + key + "}}", textData[key]);
                }
            });
        });
    };
    ImageRender.prototype.loadShareImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allImageSrcs, imageSet, key, result, allImageKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allImageSrcs = [];
                        imageSet = this.imageSet;
                        for (key in imageSet) {
                            allImageSrcs.push(imageSet[key].src);
                        }
                        return [4 /*yield*/, loadImages(allImageSrcs)];
                    case 1:
                        result = _a.sent();
                        allImageKeys = Object.keys(imageSet);
                        allImageKeys.map(function (item, index) {
                            var _a = result[index], image = _a.image, error = _a.error;
                            imageSet[item].imageObject = image;
                            if (error) {
                                Sentry.captureException(error);
                            }
                        });
                        this.loadedImageSet = imageSet;
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageRender.prototype.drawShareImageAndText = function (textSet, textData, mutipleText) {
        if (textSet === void 0) { textSet = []; }
        // set text template
        if (textData) {
            this.setTextTemplate(textSet, textData);
        }
        // draw image
        this.drawImage();
        if (mutipleText) {
            this.drawMultipleRowsText(mutipleText);
        }
        this.drawText(textSet);
    };
    ImageRender.prototype.drawMultipleRowsText = function (mutipleText) {
        var _this = this;
        mutipleText.map(function (item) {
            var ctx = _this.ctx;
            ctx.save();
            if (item.fillStyle) {
                ctx.fillStyle = item.fillStyle;
            }
            if (item.font) {
                ctx.font = item.font;
            }
            var lineHeight = item.lineHeight || 36; // 行高
            var initHeight = 0; // 距离顶部的距离
            var lastSubStrIndex = 0; // 每次开始截取的字符串的索引
            var lineWidth = 0;
            var _a = item.position || { x: 0, y: 0 }, x = _a.x, y = _a.y;
            var contentWidth = item.contentWidth || 470;
            var text = item.text;
            for (var i = 0; i < text.length; i += 1) {
                lineWidth += ctx.measureText(text[i]).width;
                if (lineWidth > contentWidth) {
                    ctx.fillText(text.substring(lastSubStrIndex, i), x, initHeight + y); // 绘制截取部分
                    initHeight += lineHeight;
                    lineWidth = 0;
                    lastSubStrIndex = i;
                }
                if (i === text.length - 1) {
                    // 绘制剩余部分
                    ctx.fillText(text.substring(lastSubStrIndex, i + 1), x, initHeight + y);
                }
            }
            ctx.restore();
        });
    };
    ImageRender.prototype.drawImage = function () {
        var ctx = this.ctx;
        var loadedImageSet = this.loadedImageSet;
        if (window.devicePixelRatio) {
            ctx.scale(this.scale, this.scale);
        }
        var _loop_1 = function (item) {
            var imageObject = loadedImageSet[item].imageObject;
            if (!imageObject) {
                return "continue";
            }
            loadedImageSet[item].drawData.map(function (drawData) {
                var clip = drawData.clip;
                var _a = drawData.size || {
                    width: null,
                    height: null,
                }, width = _a.width, height = _a.height;
                var _b = drawData.position || { x: 0, y: 0 }, x = _b.x, y = _b.y;
                ctx.save();
                if (clip && clip.type === 'arc') {
                    ctx.beginPath();
                    ctx.arc(clip.args.x, clip.args.y, clip.args.radius, 0, Math.PI * 2, true);
                    ctx.clip();
                }
                ctx.translate(x, y);
                try {
                    if (width && height) {
                        ctx.drawImage(imageObject, 0, 0, width, height);
                    }
                    else {
                        ctx.drawImage(imageObject, 0, 0);
                    }
                }
                catch (e) {
                    Sentry.captureException(e);
                }
                ctx.restore();
            });
        };
        for (var item in loadedImageSet) {
            _loop_1(item);
        }
    };
    ImageRender.prototype.calculateTextSetWidth = function (textSetNode) {
        var ctx = this.ctx;
        var totalWidth = 0;
        var textContentArr = textSetNode.text;
        textContentArr.map(function (textNode) {
            ctx.save();
            if (textSetNode.fillStyle) {
                ctx.fillStyle = textSetNode.fillStyle;
            }
            if (textSetNode.font) {
                ctx.font = textSetNode.font;
            }
            if (textSetNode.textAlign) {
                ctx.textAlign = textSetNode.textAlign;
            }
            if (textNode.fillStyle) {
                ctx.fillStyle = textNode.fillStyle;
            }
            if (textNode.font) {
                ctx.font = textNode.font;
            }
            totalWidth += ctx.measureText(textNode.content).width;
            ctx.restore();
        });
        return totalWidth;
    };
    ImageRender.prototype.drawText = function (textSet) {
        var _this = this;
        var ctx = this.ctx;
        textSet.map(function (item) {
            ctx.save();
            var currentTextWidth = 0;
            var textContentArr = item.text;
            var totalTextWidth = _this.calculateTextSetWidth(item);
            textContentArr.map(function (textNode, index) {
                if (item.fillStyle) {
                    ctx.fillStyle = item.fillStyle;
                }
                if (item.font) {
                    ctx.font = item.font;
                }
                if (textNode.fillStyle) {
                    ctx.fillStyle = textNode.fillStyle;
                }
                if (textNode.font) {
                    ctx.font = textNode.font;
                }
                var _a = item.position || { x: 0, y: 0 }, x = _a.x, y = _a.y;
                var _b = textNode.relativePosition || { relativeX: 0, relativeY: 0 }, relativeX = _b.relativeX, relativeY = _b.relativeY;
                var finalX = x + relativeX + currentTextWidth;
                if (item.textAlign === 'center') {
                    finalX = x - totalTextWidth / 2 + relativeX + currentTextWidth;
                }
                if (item.textAlign === 'right') {
                    finalX = x - totalTextWidth + relativeX + currentTextWidth;
                }
                ctx.fillText(textNode.content, finalX, y + relativeY);
                currentTextWidth += ctx.measureText(textNode.content).width;
            });
            ctx.restore();
        });
    };
    ImageRender.prototype.getDrawedImageData = function () {
        var base64 = this.canvas.toDataURL();
        return base64;
    };
    ImageRender.prototype.drawBorder = function (circle) {
        var ctx = this.ctx;
        ctx.beginPath();
        ctx.strokeStyle = circle.strokeStyle;
        ctx.arc(circle.position.x, circle.position.y, circle.radius, 0, 2 * Math.PI);
        ctx.stroke();
    };
    ImageRender.prototype.drawLine = function (line) {
        var ctx = this.ctx;
        ctx.beginPath();
        ctx.lineWidth = line.width;
        if (line.lineCap) {
            ctx.lineCap = line.lineCap;
        }
        if (line.strokeStyle) {
            ctx.strokeStyle = line.strokeStyle;
        }
        ctx.moveTo(line.origin.x, line.origin.y);
        ctx.lineTo(line.destination.x, line.destination.y);
        ctx.stroke();
    };
    ImageRender.shadowCanvas = (function () {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!canvas || !ctx) {
            toast.fail('Canvas not supported', 2);
            throw new Error('Canvas not supported');
        }
        return canvas;
    })();
    return ImageRender;
}());
export { ImageRender };
//# sourceMappingURL=imageRender.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/utils/imageRender.js
// module id = 1221
// module chunks = 0